import { render, staticRenderFns } from "./PostCardBack.vue?vue&type=template&id=174681a0&scoped=true"
import script from "./PostCardBack.vue?vue&type=script&lang=js"
export * from "./PostCardBack.vue?vue&type=script&lang=js"
import style0 from "./PostCardBack.vue?vue&type=style&index=0&id=174681a0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174681a0",
  null
  
)

export default component.exports